import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import AppointmentService from '../utils/AppointmentService.js';
import CreateAccount from './CreateAccount.js';
import { Switch, Route, Link } from 'react-router-dom'

// if (!window.Promise) {
//   window.Promise = Promise;
// }
class ErrorMessage extends Component {

  constructor(props) {
    super(props)
  }


    render(){
      return (
              <div className='errorContainer'>
                {this.props.error}
              </div>
              )
    }
}
export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/Components/ErrorMessage.js